<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/adminTools"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Μη Επιβεβαιωμένες Παρουσίες - Ενημέρωση Διάρκειας OTP</u></h4>
        </div>
      </div>

      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <br />
        <DxButton2
          text="Ενημέρωση"
          class="col-md-2 pull-right"
          name="editOTPValidUntil"
          icon="event"
          hint="Ενημέρωση Ημερομηνίας Λήξης OTP"
          style="text-align: center"
          :on-click="changeOtpValidUntil"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          :data-source="verifications"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          key-expr="Id"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          width="100%"
        >
          <DxPaging :page-size="20" :enabled="true" />
          <DxEditing :allow-updating="false" />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />

          <DxColumn
            caption="Ωφελούμενη/ος"
            :allow-editing="false"
            data-field="ParentFullName"
            data-type="string"
            :visible="true"
            alignment="left"
          >
          </DxColumn>

          <DxColumn
            caption="Εξυπηρετούμενο Άτομο"
            :allow-editing="false"
            data-field="KidFullName"
            :visible="true"
            alignment="left"
            :allow-filtering="true"
          >
          </DxColumn>

          <DxColumn
            caption="OTP Ενεργό Έως"
            :allow-editing="false"
            data-type="datetime"
            display-format="dd/MM/yyyy HH:mm"
            data-field="OneTimePasswordValidUntil"
            :visible="true"
            alignment="left"
            :allow-filtering="true"
          >
          </DxColumn>

          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: masterrow }">
            <DetailTemplate :template-data="masterrow" />
          </template>
        </DxDataGrid>
      </div>
    </div>
    <DxPopup
      :visible="showOtpValidUntilPopup"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="true"
      :width="600"
      :height="200"
      @hiding="onHiding"
      title="Αλλαγή Διάρκειας OTP Ανεπιβεβαίωτων Παρουσιών"
    >
      <DxValidationGroup :ref="groupRefKey">
        <div class="dx-field">
          <div class="dx-field-label">Διάρκεια OTP Έως</div>
          <div class="dx-field-value">
            <DxDateBox
              :value="this.newOtpValidUntil"
              type="datetime"
              display-format="dd/MM/yyyy HH:mm"
              @value-changed="setSelectedDate"
              :min="this.today"
            >
              <DxValidator>
                <DxRangeRule
                  :min="this.today"
                  message="Η ημ/νία πρέπει να είναι μεγαλύτερη ή ίση από τη σημερινή!"
                />
              </DxValidator>
            </DxDateBox>
          </div>
        </div>
      </DxValidationGroup>
      <br />
      <DxButton2
        class="pull-right"
        text="Αποθήκευση"
        icon="save"
        type="success"
        styling-mode="contained"
        @click="onSaveOtpValidUntil"
      />
    </DxPopup>
  </div>
</template>
<script>
import BackButton from "../../components/shared/backButton";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import mainService from "../../services/mainService";
import DetailTemplate from "../verifications/verficationDetails";
import { DxButton as DxButton2 } from "devextreme-vue/button";
import { DxPopup } from "devextreme-vue/popup";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import notify from "devextreme/ui/notify";
import DxDateBox from "devextreme-vue/date-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import { DxValidator, DxRangeRule } from "devextreme-vue/validator";

export default {
  name: "editVerificationsOtpValidUntil",
  components: {
    BackButton,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DetailTemplate,
    DxMasterDetail,
    DxButton2,
    DxPopup,
    DxLoadIndicator,
    DxDateBox,
    DxValidationGroup,
    DxValidator,
    DxRangeRule,
  },
  data() {
    return {
      groupRefKey: "targetGroup",
      verifications: [],
      showOtpValidUntilPopup: false,
      newOtpValidUntil: "",
      loadIndicatorVisible: false,
      today: this.$moment().format("YYYY/MM/DD"),
    };
  },
  mounted() {
    this.getVerifications();
    this.newOtpValidUntil = this.$moment().format("YYYY/MM/DD");
  },
  computed: {
    validationGroup: function () {
      return this.$refs[this.groupRefKey].instance;
    },
  },
  methods: {
    async getVerifications() {
      this.loadIndicatorVisible = true;
      this.verifications = [];
      const res = await mainService.get(
        `/Verifications/GetUnverifiedVerificationRecordsOfLastMonth`
      );
      this.verifications = res.data;
      this.loadIndicatorVisible = false;
    },
    changeOtpValidUntil() {
      this.showOtpValidUntilPopup = true;
      return;
    },
    async onSaveOtpValidUntil(e) {
      var result = this.validationGroup.validate();
      debugger;
      if (result.isValid)
        try {
          const res = await mainService.get(
            `/Verifications/UpdateVerificationOtpValidUntil?newOtpValidUntil=${this.newOtpValidUntil}`
          );
          if (res) {
            this.showOtpValidUntilPopup = false;
            this.getVerifications();
            notify("Οι εγγραφές ενημερώθηκαν επιτυχώς!", "success", 5000);
          }
        } catch (e) {
          notify("Η ενημέρωση απέτυχε. Δοκιμάστε ξανά!", "error", 5000);
        }
      else notify("Η ενημέρωση απέτυχε. Διορθώστε την ημ/νία!", "error", 5000);
    },
    onHiding() {
      this.showOtpValidUntilPopup = false;
      return;
    },
    setSelectedDate(e) {
      this.newOtpValidUntil = this.$moment(e.value).format("YYYY/MM/DD HH:mm");
    },
    validateGroup() {
      return this.validationGroup.validate();
    },
  },
};
</script>
<style lang="">
</style>